import * as THREE from "three";
import * as TWEEN from "@tweenjs/tween.js";

function PlayControls(ctx, camera) {
  var object = camera || ctx.playCamera;
  var domElement = ctx.labelRenderer.domElement;

  // API

  this.enabled = true;
  this.center = new THREE.Vector3();
  this.centerOffsetY = 5;
  this.panSpeed = 0.002;
  this.zoomSpeed = 0.1;
  this.rotationSpeed = 0.005;
  this.minZoom = 15;
  this.maxZoom = 30;
  this.maxRotation = Math.PI / 2.2;
  this.previousCamPos = null;
  this.previousCamLookAt = null;

  // internals

  var scope = this;
  var vector = new THREE.Vector3();
  var delta = new THREE.Vector3();
  var box = new THREE.Box3();

  var STATE = {NONE: -1, ROTATE: 0, ZOOM: 1, PAN: 2};
  var state = STATE.NONE;

  var center = this.center;
  var joystickId = 0;
  var controlId = 1;
  var normalMatrix = new THREE.Matrix3();
  var pointer = new THREE.Vector2();
  var pointerOld = new THREE.Vector2();
  var spherical = new THREE.Spherical();
  var sphere = new THREE.Sphere();
  var distance = null;

  // events

  var changeEvent = {type: "change"};

  this.focus = function (target) {
    var distance;

    box.setFromObject(target);

    if (box.isEmpty() === false) {
      box.getCenter(center);
      distance = box.getBoundingSphere(sphere).radius;
    } else {
      // Focusing on an Group, AmbientLight, etc

      center.setFromMatrixPosition(target.matrixWorld);
      distance = 0.1;
    }

    delta.set(0, 0, 1);
    delta.applyQuaternion(object.quaternion);
    delta.multiplyScalar(distance * 4);

    object.position.copy(center).add(delta);

    // scope.dispatchEvent( changeEvent );
  };

  this.playFocus = function (target, distance = 8, transitionSpeed = 500) {
    let startValue;
    let endValue;
    let avatarPos = ctx.avatar.model.position.clone();
    let playCamPos = object.position.clone();
    let targetPos = target.position.clone();
    let inverseTargetLookAt = new THREE.Vector3(0, 0, 1);

    inverseTargetLookAt.applyQuaternion(target.quaternion).normalize();

    let camEndPos = new THREE.Vector3().addVectors(targetPos, inverseTargetLookAt.multiplyScalar(distance));

    camEndPos.add(new THREE.Vector3(0, 2, 0));

    if (!this.previousCamPos && !this.previousCamLookAt) {
      this.enabled = false;
      ctx.avatar.model.visible = false;
      ctx.avatar.changeNicknameVisibility(false);

      this.previousCamLookAt = avatarPos;
      this.previousCamPos = playCamPos;
      startValue = {
        lx: avatarPos.x,
        ly: avatarPos.y,
        lz: avatarPos.z,
        px: playCamPos.x,
        py: playCamPos.y,
        pz: playCamPos.z,
      };
      endValue = {
        lx: targetPos.x,
        ly: camEndPos.y,
        lz: targetPos.z,
        px: camEndPos.x,
        py: camEndPos.y,
        pz: camEndPos.z,
      };
    } else {
      ctx.avatar.model.visible = true;
      ctx.avatar.changeNicknameVisibility(true);

      startValue = {
        lx: targetPos.x,
        ly: targetPos.y,
        lz: targetPos.z,
        px: playCamPos.x,
        py: playCamPos.y,
        pz: playCamPos.z,
      };
      endValue = {
        lx: this.previousCamLookAt.x,
        ly: this.previousCamLookAt.y + this.centerOffsetY,
        lz: this.previousCamLookAt.z,
        px: this.previousCamPos.x,
        py: this.previousCamPos.y,
        pz: this.previousCamPos.z,
      };
      this.previousCamLookAt = null;
      this.previousCamPos = null;
    }

    new TWEEN.Tween(startValue)
      .to(endValue, transitionSpeed)
      // .easing(TWEEN.Easing.Elastic.Out)
      .onUpdate(() => {
        object.lookAt(startValue.lx, startValue.ly, startValue.lz);
        object.position.set(startValue.px, startValue.py, startValue.pz);
      })
      .start()
      .onComplete(() => {
        if (!this.previousCamPos && !this.previousCamLookAt) {
          this.enabled = true;
        }
      });
  };

  this.pan = function (delta) {
    /*
		var distance = object.position.distanceTo( center );

		delta.multiplyScalar( distance * scope.panSpeed );
		delta.applyMatrix3( normalMatrix.getNormalMatrix( object.matrix ) );

		object.position.add( delta );
		center.add( delta );

		scope.dispatchEvent( changeEvent );
		*/
  };

  this.zoom = function (delta) {
    distance = object.position.distanceTo(center);

    delta.multiplyScalar(distance * scope.zoomSpeed);

    if (delta.length() > distance) return;

    delta.applyMatrix3(normalMatrix.getNormalMatrix(object.matrix));

    object.position.add(delta);

    // scope.dispatchEvent( changeEvent );
  };

  this.rotate = function (delta) {
    // Custom code: let orbit center follow model's position
    if (ctx.avatar?.model !== undefined) center.copy(ctx.avatar.model.position);

    vector.copy(object.position).sub(center);

    spherical.setFromVector3(vector);

    spherical.theta += delta.x * scope.rotationSpeed;

    if (spherical.phi + delta.y * scope.rotationSpeed > this.maxRotation) {
      spherical.phi = this.maxRotation;
    } else {
      spherical.phi += delta.y * scope.rotationSpeed;
    }

    spherical.makeSafe();

    vector.setFromSpherical(spherical);
    object.position.copy(center).add(vector);

    object.lookAt(center.x, center.y + this.centerOffsetY, center.z);

    // scope.dispatchEvent( changeEvent );
  };

  function onPointerDown(event) {
    if (scope.enabled === false) return;

    switch (event.pointerType) {
      case "mouse":
      case "pen":
        onMouseDown(event);
        break;
      default:
        break;
      // TODO touch
    }

    domElement.ownerDocument.addEventListener("pointermove", onPointerMove, false);
    domElement.ownerDocument.addEventListener("pointerup", onPointerUp, false);
  }

  function onPointerMove(event) {
    if (scope.enabled === false) return;

    switch (event.pointerType) {
      case "mouse":
      case "pen":
        onMouseMove(event);
        break;
      default:
        break;
      // TODO touch
    }
  }

  function onPointerUp(event) {
    switch (event.pointerType) {
      case "mouse":
      case "pen":
        onMouseUp();
        break;
      default:
        break;
      // TODO touch
    }

    domElement.ownerDocument.removeEventListener("pointermove", onPointerMove, false);
    domElement.ownerDocument.removeEventListener("pointerup", onPointerUp, false);
  }

  // mouse

  function onMouseDown(event) {
    if (event.button === 0) {
      state = STATE.ROTATE;
    } else if (event.button === 1) {
      state = STATE.ZOOM;
    } else if (event.button === 2) {
      state = STATE.PAN;
    }

    pointerOld.set(event.clientX, event.clientY);
  }

  function onMouseMove(event) {
    pointer.set(event.clientX, event.clientY);

    var movementX = pointer.x - pointerOld.x;
    var movementY = pointer.y - pointerOld.y;

    if (state === STATE.ROTATE) {
      scope.rotate(delta.set(-movementX, -movementY, 0));
    } else if (state === STATE.ZOOM) {
      scope.zoom(delta.set(0, 0, movementY));
    } else if (state === STATE.PAN) {
      scope.pan(delta.set(-movementX, movementY, 0));
    }

    pointerOld.set(event.clientX, event.clientY);
  }

  function onMouseUp() {
    state = STATE.NONE;
  }

  function onMouseWheel(event) {
    if (scope.enabled === false) return;
    if (Object.is(event.deltaY, -0) || Object.is(event.deltaY, +0)) return;

    event.preventDefault();
    // Normalize deltaY due to https://bugzilla.mozilla.org/show_bug.cgi?id=1392460
    if (scope.minZoom > distance && event.deltaY < 0) {
      scope.zoom(delta.set(0, 0, 0));
    } else if (scope.maxZoom < distance && event.deltaY > 0) {
      scope.zoom(delta.set(0, 0, 0));
    } else {
      scope.zoom(delta.set(0, 0, event.deltaY > 0 ? 1 : -1));
    }
  }

  function contextmenu(event) {
    event.preventDefault();
  }

  this.dispose = function () {
    domElement.removeEventListener("contextmenu", contextmenu, false);
    domElement.removeEventListener("dblclick", onMouseUp, false);
    domElement.removeEventListener("wheel", onMouseWheel, false);

    domElement.removeEventListener("pointerdown", onPointerDown, false);

    domElement.removeEventListener("touchstart", touchStart, false);
    domElement.removeEventListener("touchmove", touchMove, false);
    domElement.removeEventListener("touchend", touchEnd, false);
    domElement.removeEventListener("touchcancel", touchEnd, false);
    domElement.removeEventListener("touch-propagated", propagateEvent, false);

    // EventListener & Object Remove required.
    delete ctx.playControls;
  };

  domElement.addEventListener("contextmenu", contextmenu, false);
  domElement.addEventListener("dblclick", onMouseUp, false);
  domElement.addEventListener("wheel", onMouseWheel, false);

  domElement.addEventListener("pointerdown", onPointerDown, false);

  // touch
  const touchInputs = [new TouchInput(), new TouchInput()];
  const touchInputMap = {};
  const touchActionController = new TouchActionController(ctx, scope, object, center);

  function touchStart(event) {
    if (scope.enabled === false) return;

    let validTouchCount = 0;
    event.changedTouches.forEach(touch => {
      const touchInput = touchInputs.find(touchInput => !touchInput.inUse);
      if (touchInput) {
        touchInput.init(touch, event);
        touchInputMap[touch.identifier] = touchInput;
        validTouchCount++;
        touchActionController.connectInputToActions(touchInput, validTouchCount);
      }
    });
  }

  function touchMove(event) {
    if (scope.enabled === false) return;

    event.preventDefault();
    event.stopPropagation();
    event.targetTouches.forEach(touch => {
      const touchInput = touchInputMap[touch.identifier];
      if (touchInput) {
        touchInput.update(touch, event);
      }
    });
    touchActionController.updateActions();
  }

  function touchEnd(event) {
    if (scope.enabled === false) return;

    event.changedTouches.forEach(touch => {
      const touchInput = touchInputMap[touch.identifier];
      if (touchInput) {
        touchInput.reset();
        delete touchInputMap[touch.identifier];
        touchActionController.disconnectInputFromActions(touchInput);
      }
    });
  }

  function onFirstTouch(event) {
    if (!ctx.joystick.isDynamic) {
      domElement.removeEventListener("touchstart", onFirstTouch, false);
      return;
    }
    event.touches.forEach(touch => {
      if (touch.clientX > ctx.canvas.clientWidth / 2) return;
      const isRemoved = ctx.joystick.removeJoystickGuide();
      if (isRemoved) domElement.removeEventListener("touchstart", onFirstTouch, false);
    });
  }

  function propagateEvent(event) {
    switch (event.detail.type) {
      case "touchstart":
        onFirstTouch(event.detail);
        touchStart(event.detail);
        break;
      case "touchmove":
        touchMove(event.detail);
        break;
      case "touchend":
      case "touchcancel":
        touchEnd(event.detail);
        break;
      default:
        break;
    }
  }

  domElement.addEventListener("touchstart", touchStart, false);
  domElement.addEventListener("touchmove", touchMove, false);
  domElement.addEventListener("touchend", touchEnd, false);
  domElement.addEventListener("touchcancel", touchEnd, false);
  domElement.addEventListener("touchstart", onFirstTouch, false);
  domElement.addEventListener("touch-propagated", propagateEvent, false);
}

PlayControls.prototype = Object.create(THREE.EventDispatcher.prototype);
PlayControls.prototype.constructor = PlayControls;

export {PlayControls};

class TouchInput {
  constructor() {
    this.inUse = false;
    this.event = null;
    this.prevTouch = new THREE.Vector3();
    this.currTouch = new THREE.Vector3();
  }

  init(touch, event) {
    this.currTouch.set(touch.pageX, touch.pageY, 0).divideScalar(window.devicePixelRatio);
    this.event = event;
    this.inUse = true;
  }

  update(touch, event) {
    this.prevTouch.copy(this.currTouch);
    this.currTouch.set(touch.pageX, touch.pageY, 0).divideScalar(window.devicePixelRatio);
    this.event = event;
  }

  reset() {
    this.inUse = false;
  }
}

class TouchAction {
  constructor(type, ctx, scope, object, center) {
    this.type = type;
    this.ctx = ctx;
    this.scope = scope;
    this.object = object;
    this.center = center;

    this.isActive = false;
    this.touchInputs = [];
    this.requiredInputCount = type === "zoomAction" ? 2 : 1;

    this.delta = new THREE.Vector3();
  }

  connect(touchInput) {
    this.touchInputs.push(touchInput);
    if (this.touchInputs.length === this.requiredInputCount) this.start();
  }

  disconnect(touchInput) {
    const idx = this.touchInputs.indexOf(touchInput);
    if (idx !== -1) this.touchInputs.splice(idx, 1);
    if (this.touchInputs.length < this.requiredInputCount) this.end();
  }

  disconnectAll() {
    this.touchInputs = [];
    this.end();
  }

  start() {
    if (this.type === "joystickAction") this.addJoystick();
    this.isActive = true;
  }

  end() {
    if (this.type === "joystickAction") this.removeJoystick();
    this.isActive = false;
  }

  update() {
    switch (this.type) {
      case "joystickAction":
        this.ctx.joystick.move(this.touchInputs[0].event, this.ctx.joystickAxis.element);
        break;
      case "rotateAction":
        this.delta.subVectors(this.touchInputs[0].currTouch, this.touchInputs[0].prevTouch).multiplyScalar(-5);
        // in case of mobile environment, the scalar value is changed because the user
        // input corresponding to the amount of displacement is significantly less than input of browser
        this.scope.rotate(this.delta);
        break;
      case "zoomAction":
        const prevDistance = this.touchInputs[0].prevTouch.distanceTo(this.touchInputs[1].prevTouch);
        const distance = this.touchInputs[0].currTouch.distanceTo(this.touchInputs[1].currTouch);
        const objDistance = this.object.position.distanceTo(this.center);

        if (this.scope.minZoom > objDistance && prevDistance - distance < 0) {
          this.scope.zoom(this.delta.set(0, 0, 0));
        } else if (this.scope.maxZoom < objDistance && prevDistance - distance > 0) {
          this.scope.zoom(this.delta.set(0, 0, 0));
        } else {
          this.scope.zoom(this.delta.set(0, 0, (prevDistance - distance) / 3));
        }

        // var offset0 = touches[0]
        //   .clone()
        //   .sub(getClosest(touches[0], prevTouches));
        // var offset1 = touches[1]
        //   .clone()
        //   .sub(getClosest(touches[1], prevTouches));
        // offset0.x = -offset0.x;
        // offset1.x = -offset1.x;
        // this.scope.pan(offset0.add(offset1));
        break;
      default:
        break;
    }
  }

  addJoystick() {
    if (this.isJoystickReady) return;

    const x = this.touchInputs[0].event.changedTouches[0].clientX;
    const y = this.touchInputs[0].event.changedTouches[0].clientY;

    this.ctx.joystickAxis = this.ctx.joystick.add.axis({
      styles: {
        left: window.innerWidth < 768 ? 40 : 35,
        bottom: window.innerWidth < 768 ? 15 : 35,
        size: window.innerWidth < 768 ? 75 : 100,
      },
    });

    const circle = document.getElementById("joystick");
    circle.style.display = "";
    circle.style.cssText = `background: rgba(255, 255, 255, 0.3);position: fixed;width: 96px;height: 96px;cursor: pointer;bottom: 48px; left: ${
      x - 35
    }px; top: ${y - 35}px; border-radius: 100%;`;

    this.ctx.joystickAxis.onMove(event => {
      if (!this.ctx.joystickEnabled) {
        this.ctx.joystickPosition = {top: 0, right: 0};
        this.ctx.joystickRadian = 0;
        return;
      }
      this.ctx.joystickPosition = event;
      this.ctx.joystickRadian = -Math.atan2(event.right, event.top);
    });
    this.ctx.joystick.tap(this.touchInputs[0].event, this.ctx.joystickAxis.element);

    this.isJoystickReady = true;
  }

  removeJoystick() {
    if (!this.isJoystickReady) return;

    this.ctx.joystick.up(this.ctx.joystickAxis.element);
    this.ctx.joystick.removeAxis();

    this.isJoystickReady = false;
  }
}

class TouchActionController {
  constructor(ctx, scope, object, center) {
    this.ctx = ctx;
    this.joystickAction = new TouchAction("joystickAction", ctx);
    this.rotateAction = new TouchAction("rotateAction", ctx, scope);
    this.zoomAction = new TouchAction("zoomAction", ctx, scope, object, center);
  }

  connectInputToActions(touchInput, touchCount) {
    this.zoomAction.connect(touchInput);
    if (!this.ctx.joystick.isDynamic) {
      this.rotateAction.connect(touchInput);
      return;
    }
    if (touchCount !== 1) return;
    if (touchInput.event.changedTouches[0].clientX > this.ctx.canvas.clientWidth / 2) {
      this.rotateAction.connect(touchInput);
      return;
    }
    if (this.zoomAction.isActive) return;
    this.joystickAction.connect(touchInput);
  }

  updateActions() {
    if (this.zoomAction.isActive && !this.ctx.joystick.isUsing) {
      this.zoomAction.update();
      if (this.joystickAction.isActive) this.joystickAction.disconnectAll();
    } else {
      if (this.joystickAction.isActive) this.joystickAction.update();
      if (this.rotateAction.isActive) this.rotateAction.update();
    }
  }

  disconnectInputFromActions(touchInput) {
    this.joystickAction.disconnect(touchInput);
    this.rotateAction.disconnect(touchInput);
    this.zoomAction.disconnect(touchInput);
  }
}
